import Select from '@components/select';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { moveInDateSelector, selectProductType } from '../redux/selectors';
import { getMovingDateFilterApplied } from '../services/moveInDateService';
import PlanStatus from '../enums/planStatus';
import SpecStatus from '../enums/specStatus';
import { searchParametersSlice } from '../redux/slices';
import { getInventoryStatusCombination } from '../services/homeStatusValidator';
import ProductType from '../enums/productType';

class SelectMoveInDate {
  constructor(moveInDate) {
    this.moveInDate = moveInDate;
    const selectMoveInDate$ = new Select(moveInDate).getObservable();
    selectMoveInDate$.subscribe(SelectMoveInDate.onChangeMoveInDate);
    this.moveInDateChange$ = store$.pipe(
      map(moveInDateSelector),
      distinctUntilChanged(),
      map(getMovingDateFilterApplied)
    );
    this.moveInDateChange$.subscribe(this.setMoveInDateValue.bind(this));
    store$.pipe(map(selectProductType), distinctUntilChanged()).subscribe(this.onProductTypeChange.bind(this));
  }

  static onChangeMoveInDate(value) {
    switch (value) {
      case PlanStatus.AvailableNow.toString():
      case SpecStatus.AvailableNow.toString():
      case PlanStatus.ReadyToBuild.toString():
      case SpecStatus.ReadyToBuild.toString():
      case getInventoryStatusCombination():
        store.dispatch(searchParametersSlice.actions.fetchMoveInDateByStatus(value));
        break;
      case '':
        store.dispatch(searchParametersSlice.actions.clearMoveInDateFilter(value));
        break;
      default:
        store.dispatch(searchParametersSlice.actions.fetchMoveInDateByRange(value));
        break;
    }
  }

  onProductTypeChange(productType) {
    switch (productType) {
      case ProductType.BuildOnYourLot.toString():
      case ProductType.Custom.toString():
      case ProductType.Manufactured.toString():
        this.disable();
        break;

      default:
        this.enable();
    }
  }

  disable() {
    this.moveInDate.setAttribute('disabled', '');
  }

  /**
   * Set the value of the moveInDateElement to update the select.
   * @param value - The value of move in date in the store.
   */
  setMoveInDateValue(value) {
    this.moveInDate.value = value;
  }

  enable() {
    this.moveInDate.removeAttribute('disabled');
  }

  toggleActiveClass() {
    this.moveInDateChange$.subscribe((value) => {
      if (value) {
        this.moveInDate.classList.add('nhs-c-select-button--active');
      } else {
        this.moveInDate.classList.remove('nhs-c-select-button--active');
      }
    });
  }
}

export default SelectMoveInDate;
